module.exports = __webpack_public_path__ + "img/truck-flatbed.f7880161.svg";